import { useApolloClient } from '@apollo/client';
import {
  Button,
  Card,
  CardActions,
  CardContent,
  CircularProgress,
  Typography,
} from '@mui/material';
import { FunctionComponent, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';

import { Layout } from '../../../navigation/components/Layout/Layout';
import { HeaderCard } from '../../components/HeaderCard';
import { CURRENT_EVENT } from '../../graphql/query/currentEventQuery.graphql';
import { useCurrentEventQuery } from '../../hooks/useCurrentEventQuery';

export const PaymentSuccess: FunctionComponent = () => {
  const navigate = useNavigate();
  const apolloClient = useApolloClient();
  const { loading } = useCurrentEventQuery();

  useEffect(() => {
    apolloClient.refetchQueries({
      include: [CURRENT_EVENT],
    });
  }, [apolloClient]);

  const onGoToDashboard = () => {
    navigate('/dashboard');
  };

  return (
    <Layout title="Succès du paiement" activeTab="payment" headerType="success">
      {loading ? (
        <CircularProgress />
      ) : (
        <>
          <HeaderCard />
          <Card>
            <CardContent>
              <Typography variant="h6">
                {'Votre paiement a bien été reçu.'}
              </Typography>
              <Typography variant="subtitle1">
                {
                  "En fonction de votre banque, il peut il y avoir un petit délai avant que le paiement ne soit totalement validé par Hello Asso (max 30 mn). Si votre paiement n'apparaît pas après ce délai, contactez nous !"
                }
              </Typography>
            </CardContent>
            <CardActions>
              <Button variant="contained" onClick={onGoToDashboard}>
                Retourner au Dashboard
              </Button>
            </CardActions>
          </Card>
        </>
      )}
    </Layout>
  );
};
